import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface ShareState {
    leadCreated: boolean;
    failedToCreateLead: boolean;
}
const rawState: ShareState = {
    leadCreated: false,
    failedToCreateLead: false,
};

const intialState = fromJS(rawState);

export default function createLeadReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.SET_LEAD_CREATED:
            return merge(state, fromJS({ leadCreated: action.payload.data }));
        case Actions.SET_FAILED_TO_CREATE_LEAD:
            return merge(state, fromJS({ failedToCreateLead: action.payload.data }));
        default:
            return state;
    }
}
